module.exports = {
  "$id": "ffpBinding",
  "type": "object",
  "title": "金鹏卡绑定",
  "properties": {
    "cid": {
      "title": "金鹏卡号",
      "type": "string",
      "customValidate": "ffbId"
    },
    "loginPwd": {
      "title": "密码",
      "type": "string",
      "pattern": "^\\d{6}$"
    }
  },
  "required": [
    "cid",
    "loginPwd"
  ],
  "errorMessage": {
    "cid": {
      "required": "请输入金鹏卡号/手机/身份证号"
    },
    "loginPwd": {
      "message": "金鹏密码为6位数字",
      "required": "请输入密码"
    }
  }
}
